import {load} from '@shopify/theme-sections';
import '../sections/blog-recipe';

document.addEventListener('DOMContentLoaded', () => {
  load('*');
});
